"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'DailyScheduledHoursTable',
  props: {
    data: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatSeconds: function formatSeconds(seconds) {
      var totalMinutes = Math.floor(seconds / 60);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = String(totalMinutes % 60).padStart(2, '0');
      return "".concat(hours, ":").concat(minutes);
    },
    formatSecondsWithSign: function formatSecondsWithSign(seconds) {
      var abs = Math.abs(seconds);
      var totalMinutes = Math.floor(abs / 60);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = String(totalMinutes % 60).padStart(2, '0');
      return "".concat(seconds < 0 ? '-' : '').concat(hours, ":").concat(minutes);
    }
  }
};